import React from "react";

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#101010] w-full relative overflow-hidden py-12 px-6 sm:px-12">
      <div className="max-w-6xl mx-auto text-gray-300">
        <h1 className="text-white text-4xl font-bold mb-8">Privacy Policy for FitScan</h1>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3 text-white">1. Introduction</h2>
          <p>
            FitScan (“we,” “us,” or “our”) is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and disclose personal information when you visit our website (<a href="https://fitscan.in/" target="_blank" rel="noopener noreferrer" className="text-lime-400 hover:underline">https://fitscan.in/</a>), use our services, or interact with our ads.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3 text-white">2. Information We Collect</h2>
          <p>We may collect the following types of personal information:</p>
          <ul className="list-disc list-inside space-y-1 mt-2 mb-2">
            <li>First Name and Last Name</li>
            <li>Email Address</li>
            <li>Phone Number</li>
            <li>Gender</li>
            <li>Date of Birth (DOB)</li>
          </ul>
          <p>We also collect usage data such as IP address, browser information, and device details via cookies and tracking technology.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3 text-white">3. How We Use Your Information</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Provide and improve our services</li>
            <li>Communicate with you and respond to inquiries</li>
            <li>Personalize your experience, including displaying ads</li>
            <li>Analyze usage to optimize our website</li>
            <li>Serve advertising via Google AdSense</li>
          </ul>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3 text-white">4. Google AdSense & Third-Party Advertising</h2>
          <p>
            We use Google AdSense to display ads on our Site. Google and other third-party vendors may use cookies and similar technologies to show ads based on your visits to our Site and other websites.<br />
            Learn more: <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="text-lime-400 hover:underline">Google’s Privacy Policy</a><br />
            Control ads: <a href="https://adssettings.google.com/authenticated" target="_blank" rel="noopener noreferrer" className="text-lime-400 hover:underline">Google Ad Settings</a><br />
            You can opt out of personalized ads via Google’s Ad Settings and other opt-out tools like the <a href="https://optout.networkadvertising.org/" target="_blank" rel="noopener noreferrer" className="text-lime-400 hover:underline">Network Advertising Initiative</a>.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3 text-white">5. Cookies & Consent</h2>
          <p>
            We use cookies to collect information about your preferences and visits to our Site. When you first visit our Site, you will see a cookie consent banner to accept or manage your cookie preferences. You can also decline non-essential cookies via your browser settings.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3 text-white">6. Disclosure of Information</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>With service providers helping us operate the Site</li>
            <li>In response to lawful requests or legal obligations</li>
            <li>When necessary to protect our rights</li>
          </ul>
          <p>We do not sell your personal data to third parties.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3 text-white">7. Data Security</h2>
          <p>
            We take steps to safeguard your information using technical and organizational measures, but no online system can be completely secure. Please contact us immediately if you suspect unauthorized activity.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3 text-white">8. Your Rights</h2>
          <ul className="list-disc list-inside space-y-1 mb-2">
            <li>Access, correct, or delete your personal information</li>
            <li>Opt out of certain data processing and marketing communications</li>
          </ul>
          <p>For requests, email <a href="mailto:fitscan.official@gmail.com" className="text-lime-400 hover:underline">fitscan.official@gmail.com</a>.</p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3 text-white">9. Children’s Privacy</h2>
          <p>
            Our service is not intended for children under the age of 13. We do not knowingly collect information from children. If you believe a child has provided us with personal data, please contact us for removal.
          </p>
        </section>

        <section className="mb-8">
          <h2 className="text-xl font-semibold mb-3 text-white">10. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy as practices or laws change. Any updates will be posted on this page with the latest date.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold mb-3 text-white">11. Contact Us</h2>
          <p>
            If you have any questions or requests regarding privacy, contact us at:<br />
            Email: <a href="mailto:fitscan.official@gmail.com" className="text-lime-400 hover:underline">fitscan.official@gmail.com</a><br />
            Phone: +91 93925 50556<br />
            Address: 1-149, MAIN RAOD, RELLIGADDA, ALLAVARAM, ANDHRAPRADESH 533217
          </p>
          <p className="mt-4 text-gray-500">Last updated: November 23, 2025</p>
        </section>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
